import React from "react";

export default class Hero extends React.Component {

    constructor(props) {
        super(props);
        this.state = { mobileHeroClass: 'mobile-hero' };
    }

    componentDidMount(){
        console.log('Hero class function initialized.')
        switch (this.state.mobileHeroClass === 'mobile-hero'){
            case this.state.mobileHeroClass === 'mobile-hero':
                console.log('First case taken care of.')
                this.setState({ mobileHeroClass: 'mobile-hero-1' });
        };

        this.heroTimer = setInterval(() => {
            setTimeout(() => {
                switch (this.state.mobileHeroClass === 'mobile-hero-1'){
                    case this.state.mobileHeroClass === 'mobile-hero-1':
                        console.log('Second case taken care of.')
                        this.setState({ mobileHeroClass: 'mobile-hero-2' });
                };
            }, 1500);

            setTimeout(() => {
                switch (this.state.mobileHeroClass === 'mobile-hero-2'){
                    case this.state.mobileHeroClass === 'mobile-hero-2':
                        console.log('Third case taken care of.')
                        this.setState({ mobileHeroClass: 'mobile-hero-3' });
                };
            }, 3000);

            setTimeout(() => {
                switch (this.state.mobileHeroClass === 'mobile-hero-3'){
                    case this.state.mobileHeroClass === 'mobile-hero-3':
                        console.log('Last case taken care of.')
                        this.setState({ mobileHeroClass: 'mobile-hero-1' });
                };
            }, 4500);
        }, 4500);            
    }

    componentWillUnmount() {
        clearInterval(this.heroTimer);
    }

    render() {
        return (
            <div className="hero-container">
                <div className="hero-image1">
                    <p>LUNCH</p>
                </div>
                <div className="hero-image2">
                    <p>BREAKFAST</p>
                </div>
                <div className="hero-image3">
                    <p>DINNER</p>
                </div>
                <div className={this.state.mobileHeroClass}>
                    <div className="mobile-hero-text">
                        <p>we love food<br/><span className="mht-span">With Spice</span></p>
                    </div>                    
                </div>
            </div>
        )
    }
}